import type { MessageDescriptor } from 'react-intl';

export interface Notification {
  messageId: MessageDescriptor['id'];
  level: 'info' | 'danger' | 'warning';
  helpCenterLinkId?: string;
}

export const streamingInitializingNotification: readonly Notification[] = [
  {
    messageId: 'header.notification.streamingInitialising',
    level: 'info',
  },
];
export const streamingUnavailableNotification: readonly Notification[] = [
  {
    messageId: 'header.notification.streamingUnavailable',
    level: 'danger',
  },
];
export const streamingDegradedNotification: readonly Notification[] = [
  {
    messageId: 'header.notification.streamingDegraded',
    level: 'warning',
    helpCenterLinkId: 'StreamingDegraded',
  },
];
export const userOfflineNotification: readonly Notification[] = [
  {
    messageId: 'header.notification.userOffline',
    level: 'warning',
  },
];
